import {
    Music, Video, Palette, Megaphone, Globe, GraduationCap, TrendingUp,
    Sparkles, Flame, Rocket, Crown, Star, Play,
} from "lucide-react";

export const ICONS = {
    Music, Video, Palette, Megaphone, Globe, GraduationCap, TrendingUp,
    Sparkles, Flame, Rocket, Crown, Star, Play,
};

export function Icon({ name, className }) {
    const Cmp = ICONS[name] || Sparkles;
    return <Cmp className={className} />;
}
